module.exports = ":host {\n  color: #fff; }\n  :host .file-count {\n    font-size: 0.875rem;\n    font-weight: 700;\n    opacity: 0.5;\n    letter-spacing: -0.1px;\n    background: transparent; }\n  :host .search-text {\n    font-size: 5rem;\n    line-height: 1;\n    letter-spacing: -0.4px;\n    font-weight: 300; }\n  @media (max-width: 1024px) {\n      :host .search-text {\n        font-size: 3.75rem; } }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/search-info/search-info.component.scss
// module id = ./src/app/shared/components/search-info/search-info.component.scss
// module chunks = main